import React from 'react';
import { LIBERTY_IMAGES } from '../../assets/asset';
import QuoteTokenDisplay from './QuoteTokenDisplay';

export default function SwapTokenButton({ tokenId, onOpenPicker, selection }) {
  return (
    <button
      type="button"
      onClick={onOpenPicker}
      className="inline-flex flex-col items-center justify-between bg-[var(--exchange-secondary-mobile)] md:bg-[var(--exchange-secondary-desktop)] py-1.5 md:py-1 px-2 rounded-full cursor-pointer hover:bg-[#333333] font-medium whitespace-nowrap self-start border-0 text-left"
    >
      <div className="flex items-center gap-2 w-full">
        <div className="flex items-center w-full">
          {selection ? (
            <>
              <div className="relative mr-2">
                <img
                  alt={selection.symbol}
                  className="border border-[#393941] rounded-full"
                  decoding="async"
                  height="32"
                  src={selection.image}
                  width="32"
                />
                <div className="absolute -bottom-1 -right-1">
                  <img
                    alt={selection.chain}
                    className="border border-[#393941] rounded-full"
                    decoding="async"
                    height="16"
                    src={selection.chainBadge}
                    width="16"
                  />
                </div>
              </div>
              <div className="flex flex-col items-start md:mr-2">
                <span className="text-[#F7F7F8] font-medium text-base">{selection.symbol}</span>
                <span className="text-[#9091A0] text-xs md:block hidden">{selection.chain}</span>
              </div>
            </>
          ) : (
            <QuoteTokenDisplay tokenId={tokenId} />
          )}
          <img
            alt=""
            className="ml-auto flex-shrink-0"
            decoding="async"
            height={20}
            src={LIBERTY_IMAGES.IC_CHEVRON_DOWN}
            width={20}
          />
        </div>
      </div>
    </button>
  );
}
